import TenantForm from '../screens/TenantForm'
import TenantList from '../screens/TenantList'
import TenantTabs from '../screens/TenantTabs'
import { ROLE, RouteWithAccessType } from './types'

const tenantPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/tenant',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN, ROLE.TENANT, ROLE.CHANNEL_ACTIVATION],
    rolesListWithWriteAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
    requiredFeatures: ['tenant.list.view'],
    component: <TenantList />
  },
  {
    route: '/tenant/:tenantId/:tenantCode/:page',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN, ROLE.TENANT, ROLE.CHANNEL_ACTIVATION],
    rolesListWithWriteAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
    requiredFeatures: ['tenant.details.view'],
    tabs: [
      {
        params: { page: 'details' },
        requiredFeatures: ['tenant.details.view']
      },
      {
        params: { page: 'logo' },
        requiredFeatures: ['tenant.details.view']
      },
      {
        params: { page: 'booking-permission' },
        requiredFeatures: ['tenant.booking.permission']
      },
      {
        params: { page: 'data-export' },
        requiredFeatures: ['tenant.data-export']
      }
    ],
    component: <TenantTabs />
  },
  {
    route: '/tenant/create',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
    rolesListWithWriteAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
    requiredFeatures: ['tenant.create'],
    component: <TenantForm />
  }
]

export default tenantPagesRoleManagement
